import {
  Grid,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import close from "../../asset/image/close.svg";
import { getDecodeURI, getEncodedURI } from "../../utils/util";
import { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

interface InventoryFiltersProps {
  setFilterPopup: (open: boolean) => void;
  fetchInventoryDeployedData: (payload: any) => void;
  payload: any;
  location: any;
  history: any;
}

const filterOptions = [
  { label: "Registered devices", queryValue: "Only-Registered" },
  { label: "De-Registered Queue", queryValue: "DeRegistered-Q" },
  { label: "Not Registered", queryValue: "Not-registered" },
  { label: "Paused", queryValue: "Paused", isPaused: true },
  { label: "Scheduled Pause", queryValue: "Paused", isPauseQueue: true },
  { label: "Site with no device", queryValue: "Empty-Sites" },
];

const InventoryFilters = ({
  setFilterPopup,
  fetchInventoryDeployedData,
  payload,
  location,
  history,
}: InventoryFiltersProps) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [pausedSelected, setPausedSelected] = useState(false);
  const [pauseQueueSelected, setPauseQueueSelected] = useState(false);

  useEffect(() => {
    if (payload.deregQ) {
      const decoded = decodeURIComponent(payload.deregQ).trim();
      const options: string[] = [];
      const matches = decoded.match(/IN\(([^)]+)\)/);
      if (matches) {
        options.push(...matches[1].split(",").map((v) => v.replace(/'/g, "").trim()));
      }
      setSelectedOptions(options);
      setPausedSelected(decoded.includes("licenseType='Paused'"));
      setPauseQueueSelected(decoded.includes("pausedOn>="));
    } else {
      setSelectedOptions([]);
      setPausedSelected(false);
      setPauseQueueSelected(false);
    }
  }, [payload.deregQ]);

  const handleToggle = (option: { queryValue: string; isPaused?: boolean; isPauseQueue?: boolean }) => {
    if (option.isPaused) {
      setPausedSelected((prev) => !prev);
    } else if (option.isPauseQueue) {
      setPauseQueueSelected((prev) => !prev);
    } else {
      setSelectedOptions((prev) =>
        prev.includes(option.queryValue) ? prev.filter((v) => v !== option.queryValue) : [...prev, option.queryValue]
      );
    }
  };

  const buildQuery = () => {
    const innerParts: string[] = [];
    if (selectedOptions.length > 0) {
      const joined = selectedOptions.map((opt) => `'${opt}'`).join(",");
      innerParts.push(`Reg_status IN(${joined})`);
    }
    if (pausedSelected) {
      innerParts.push(`licenseType='Paused'`);
    }
    if (pauseQueueSelected) {
      innerParts.push(`(licenseType!='Paused' and pausedOn>=now())`);
    }
    if (innerParts.length === 0) return '';
    return `and (${innerParts.join(' or ')})`;
  };

  const handleApplyFilter = () => {
    const query = buildQuery();
    const updatedParams = getDecodeURI(location.search);
    updatedParams.deregQ = encodeURIComponent(query);
    history.push({ pathname: location.pathname, search: `?${getEncodedURI(updatedParams)}` });

    fetchInventoryDeployedData({
      ...payload,
      deregQ: query,
    });

    setFilterPopup(false);
  };

  const handleClearFilter = () => {
    setSelectedOptions([]);
    const updatedParams = getDecodeURI(location.search);
    delete updatedParams.deregQ;
    history.push({ pathname: location.pathname, search: `?${getEncodedURI(updatedParams)}` });

    fetchInventoryDeployedData({
      ...payload,
      deregQ: "",
    });

    setFilterPopup(false);
  };

  return (
    <div className="Form">
      <Grid className="am-table">
        <Grid className="dash-filter-pop">
          <Grid className="login-history-filter-inputs">
            <Grid className="filter-clearFilter login-filter-clearFilter">
              <div className="Filters_Title">Filters</div>
              <img
                src={close}
                onClick={() => setFilterPopup(false)}
                className="dialog_closeIcon-filters"
                alt="Close"
              />
            </Grid>

            <Grid className="sitesFiltersPadding rc--filter_section">
              <Grid container spacing={0.5}>
                {filterOptions.map((option, index) => (
                  <Grid item xs={12} key={index} className="filter-grid">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={(option as any).isPauseQueue ? pauseQueueSelected : (option as any).isPaused ? pausedSelected : selectedOptions.includes(option.queryValue)}
                          onChange={() => handleToggle(option as any)}
                          className="filter-checkbox-padding"
                        />
                      }
                      label={option.label}
                      className="sitesInternetStatusOptions sitesoptions"
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <div className="clearApplyFilters">
            <Button onClick={handleClearFilter} className="clearFiltersButton">
              Clear Filter
            </Button>
            <Button className="usage-applyFilterBtn" onClick={handleApplyFilter}>
              Apply Filter
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default withRouter(InventoryFilters);
